var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { memo } from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { ErrorBoundary, Icon } from '@web/utils';
import { styled } from '@web/theme';
import { DeleteButton } from './DeleteButton';
import { BlockType } from '../../';
import { faImage, faNewspaper } from '@fortawesome/free-solid-svg-icons';
export var LibraryItem = memo(function (props) {
    return (React.createElement(ErrorBoundary, null,
        React.createElement(Draggable, { draggableId: props._id, index: 0 }, function (provided, snapshot) { return (React.createElement(Wrapper, __assign({ ref: provided.innerRef }, provided.draggableProps, provided.dragHandleProps),
            React.createElement(Item, null,
                React.createElement(Icon, { icon: props._type === BlockType.TEXT ? faNewspaper : faImage }),
                props._title),
            React.createElement(DeleteButton, { id: props._id }))); })));
});
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: flex;\n\tfont-size: 12px;\n\tpadding: .2rem .5rem;\n\talign-items: center;\n\t\n\t&:hover {\n\t\tbackground-color: rgba(255, 255, 255, .1);\n\t}\n"], ["\n\tdisplay: flex;\n\tfont-size: 12px;\n\tpadding: .2rem .5rem;\n\talign-items: center;\n\t\n\t&:hover {\n\t\tbackground-color: rgba(255, 255, 255, .1);\n\t}\n"])));
var Item = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tdisplay: flex;\n\t\n\t> *:first-child {\n\t\tmargin-right: .5rem;\n\t}\n"], ["\n\tdisplay: flex;\n\t\n\t> *:first-child {\n\t\tmargin-right: .5rem;\n\t}\n"])));
var templateObject_1, templateObject_2;
